<template lang="pug">
  el-table(
    style='width: 100%;'
    header-cell-class-name='table-header'
    cell-class-name='pl-4'
    :data='firmwares'
  )
    el-table-column(
      width="55"
    )
      template(slot-scope='scope')
        span.pre-line {{ scope.$index + 1}}
    el-table-column(
      prop='version'
      :label="$t('firmwares.label.version')"
    )
      template(slot-scope='scope')
        span {{ buildDateTime(scope.row.firmware.build_time) }}
    el-table-column(
      prop='length'
      :label="$t('firmwares.label.length')"
    )
      template(slot-scope='scope')
        span {{ scope.row.firmware.length }} {{ 'bytes' }}
    el-table-column(
      prop='fnv'
      :label="$t('firmwares.label.fnv')"
    )
      template(slot-scope='scope')
        span {{ scope.row.firmware.fnv }}
    el-table-column(
      prop='updatedAt'
      :label="$t('firmwares.label.updated_at')"
    )
      template(slot-scope='scope')
        span {{ buildDateTime(scope.row.updated_at) }}
    el-table-column(
      prop='latest'
      :label="$t('firmwares.label.current')"
    )
      template(slot-scope='scope')
        el-tag(v-if="scope.row.latest" type="success") {{ $t('firmwares.label.current_tag') }}
        span(v-else) {{ "-" }}
</template>

<script>

export default {
  name: "SiteFirmwaresViewTable",

  props: {
    firmwares: {
      type: Array,
    },
    siteId: {
      type: String,
    },
  },

  methods: {
    buildDateTime(dateValue) {
      const localDate = new Date(dateValue);
      const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

      const day = localDate.getDate().toString().padStart(2, '0');
      const monthName = months[localDate.getMonth()];
      const year = localDate.getFullYear();

      const timeStr = localDate.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      });

      return `${timeStr} on ${day} ${monthName} ${year}`;
    },
  },
};
</script>